import React, { useState, useEffect } from "react"
import _isEmpty from "lodash/isEmpty"

import { validateField, sanitizeObject } from "@/utils/helper"
import newsLetterBody from "@/components/Shared/NewsletterFooter/newsLetterBody"
import { apim } from "@/constants/api"
import { emailSubscribeEndPoint } from "@/constants"
import Form from "./Form"
import FormSuccessMessage from "./FormSuccessMessage"

const LeadGenView = props => {
  const {
    i18n,
    submitSuccess,
    brandName,
    isNewTab,
    showToaster,
    teaserComponent,
  } = props

  const [userData, setUserData] = useState({
    fname: "",
    lname: "",
    email: "",
    state: {},
    zipcode: "",
    country: {},
    occupation: "",
  })
  const [error, setError] = useState({})
  const [loading, setLoading] = useState(false)

  const validateExist = async field => {
    switch (field) {
      case "fname":
      case "lname":
        if (
          !userData[field].trim() ||
          !(await validateField("name", userData[field]))
        ) {
          return field === "fname" ? i18n.fnameError : i18n.lnameError
        }
        break
      case "email":
        if (!userData[field]) return i18n.noEmailError
        else if (!(await validateField("email", userData[field])))
          return i18n.validEmail
        break
      case "zipcode":
        if (!userData.zipcode.trim()) return i18n.zipcodeError
        else if (userData.zipcode.length < 5) return i18n.validZipcode
        break
      case "state":
        if (!userData.state || _isEmpty(userData.state)) return i18n.stateError
        break
      case "occupation":
        if (userData.occupation.trim() === "") return i18n.occupationError
        break
      default:
        return
    }
  }

  const onBlurError = async field => {
    setError({
      ...error,
      [field]: await validateExist(field),
    })
  }

  const getErrorList = async () => {
    let errorList = {
      fname: await validateExist("fname"),
      lname: await validateExist("lname"),
      email: await validateExist("email"),
      zipcode: await validateExist("zipcode"),
      state: await validateExist("state"),
      occupation: await validateExist("occupation"),
    }
    return errorList
  }

  const onSubmit = async () => {
    setLoading(true)
    let errorDataList = []
    const errorList = await getErrorList()

    setError(errorList)
    if (errorList.fname) {
      errorDataList.push(`contact-user-fname`)
    } else if (errorList.lname) {
      errorDataList.push(`contact-user-lname`)
    } else if (errorList.email) {
      errorDataList.push(`contact-user-email`)
    } else if (errorList.zipcode) {
      errorDataList.push(`contact-user-zipcode`)
    } else if (errorList.state) {
      errorDataList.push(`contact-user-state`)
    } else if (errorList.occupation) {
      errorDataList.push(`contact-user-occupation-type`)
    }

    errorDataList.forEach((item, i) => {
      if (i === 0) document.getElementById(`${item}`).focus()
    })

    const isInvalid = Object.values(errorList).find(el => el)
    const { fname, lname, email, state, zipcode, country, occupation } =
      userData

    if (!isInvalid) {
      const additionalValues = {
        "First Name": fname,
        "Last Name": lname,
        State: state.code,
        "Zip or Postal Code": zipcode,
        Country: country?.name,
        Occupation: occupation,
      }
      let body = newsLetterBody(brandName, email, null, additionalValues)
      sanitizeObject(body)
      setLoading(false)
      apim
        .post(emailSubscribeEndPoint, body, {
          params: {
            brand: brandName,
          },
        })
        .then(response => {
          if (response?.data) {
            const isSuccess = response?.data?.resultMessages ?? []
            if (isSuccess) {
              teaserComponent?.classList?.add?.("d-none")
              props.handleSubmitMsg(true)
            }
          } else {
            showToaster(
              "News letter subscription API: Error occured while fetching data from Get URL Property"
            )
          }
        })
        .catch(err => {
          if (
            err.response?.data?.error === "Email address already subscribed"
          ) {
            showToaster(i18n?.alreadySubscribed)
          } else {
            showToaster(i18n?.genError)
          }
        })
    } else {
      setLoading(false)
    }
  }

  return !submitSuccess ? (
    <div className="kf-react-container">
      <div className="lead-gen-main">
        <Form
          i18n={i18n}
          data={userData}
          setData={setUserData}
          error={error}
          setError={setError}
          onBlur={onBlurError}
          onSubmit={onSubmit}
          loading={loading}
          teaserComponent={teaserComponent}
        />
      </div>
    </div>
  ) : (
    <FormSuccessMessage
      i18n={i18n}
      setSubmitSuccess={props.handleSubmitMsg}
      continueShoppingUrl={props.continueShoppingUrl}
      isNewTab={isNewTab}
    />
  )
}

export default LeadGenView
